import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Truck, AlertTriangle } from "lucide-react";

export default function VehicleAlertsCard() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/maintenance/vehicle-alerts").then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid="vehicle-alerts-card">
      <h2 className="text-base font-bold text-slate-900 flex items-center gap-2"><Truck className="w-4 h-4 text-amber-500" /> Vehicle MOT &amp; Service</h2>
      <p className="text-xs text-slate-500 mt-0.5 mb-3">Upcoming and overdue checks across Plant Transport.</p>
      <ul className="space-y-2">
        {items.map((a, i) => {
          const overdue = a.status === "overdue";
          const isDoc = a.kind === "MOT Certificate";
          const rightLabel = isDoc ? "Out of date" : (overdue ? `${Math.abs(a.days_left)}d overdue` : `${a.days_left}d`);
          const subline = isDoc ? (a.note || "Certificate out of date") : `Due ${a.due}`;
          return (
            <Link key={i} to={`/plant-transport/${a.vehicle_legacy_id}`}
              className={`flex items-center gap-2 rounded-lg border px-3 py-2 hover:shadow-sm transition-shadow ${overdue ? "border-rose-200 bg-rose-50/50" : "border-amber-200 bg-amber-50/50"}`}
              data-testid={`vehicle-alert-${a.vehicle_legacy_id}-${a.kind}`}>
              <AlertTriangle className={`w-4 h-4 shrink-0 ${overdue ? "text-rose-500" : "text-amber-500"}`} />
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-slate-800 truncate">{a.title} · {a.kind}</div>
                <div className="text-[11px] text-slate-500">{a.registration || ""} · {subline}</div>
              </div>
              <span className={`text-xs font-semibold shrink-0 ${overdue ? "text-rose-600" : "text-amber-600"}`}>{rightLabel}</span>
            </Link>
          );
        })}
      </ul>
    </div>
  );
}
